import { render, staticRenderFns } from "./circle.vue?vue&type=template&id=80e03bcc&scoped=true&"
import script from "./circle.vue?vue&type=script&lang=js&"
export * from "./circle.vue?vue&type=script&lang=js&"
import style0 from "./circle.vue?vue&type=style&index=0&id=80e03bcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e03bcc",
  null
  
)

export default component.exports